<div class="card">
  <div class="card-body">
    <h5 class="card-title">Reconcilation Completed Report</h5>
    <div class="description">
      Export the final coding (Reconciliation Completed O3) for abstracts which were reconciled between the selected dates.
      The generated Excel file can then be used for submitting DB coding updates.
    </div>
    <form [formGroup]="coderForm" (ngSubmit)="onSubmit()">
      <div class="mt-3">
        <div class="d-inline-block mr-3">
          <mat-form-field>
            <input matInput [matDatepicker]="pickerFrom" formControlName="startDate" placeholder="Start Date">
            <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerFrom></mat-datepicker>
            <mat-error *ngIf="coderForm.get('startDate').hasError('required')">End date is required.</mat-error>
          </mat-form-field>
        </div>
        <div class="d-inline-block mr-3">
          <mat-form-field>
            <input matInput [matDatepickerFilter]="endDateFilter" [matDatepicker]="pickerTo" formControlName="endDate" placeholder="End Date">
            <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerTo></mat-datepicker>
            <mat-error *ngIf="coderForm.get('endDate').hasError('required')">End date is required.</mat-error>
            <mat-error *ngIf="coderForm.get('endDate').hasError('matDatepickerFilter')">End date cannot be earlier than start date.</mat-error>
          </mat-form-field>
        </div>
      </div>
      <button mat-button class="btn my-3" [ngClass]="coderForm.valid ? 'btn-success' : 'btn-danger'">Run Report</button>
    </form>
  </div>
</div>
